<template>
    <div class="card h-100" style="min-height: 590px !important">
        <div class="border-0 card-header">
            <div class="row">
                <div class="col-9">
                    <h2 class="mb-0">Drop Status</h2>
                    <p class="m-0">Today, {{ moment(new Date()).format('MMMM Do YYYY') }}</p>
                </div>
                <div class="col-3 text-right">
                    <base-input placeholder="Example select" v-if="showBranchFilter === true">
                        <select class="form-control" v-model="branchFilter">
                            <option :value="null">All Branches</option>
                            <option v-for="db in dropBranches" :value="db.id" :key="db.id">{{ db.name }}</option>
                        </select>
                    </base-input>
                </div>
            </div>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="processedDrops">
            <el-table-column label="ID"
                             min-width="70px"
                             prop="name"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">#{{row.id}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Status"
                             prop="budget"
                             min-width="120px"
                             >
                <template v-slot="{row}">
                    <badge class="badge-dot badge-xl mr-4" type="">
                        <i :class="`bg-${row.statusType}`"></i>&nbsp;
                        <span class="status">{{row.status}}</span>
                    </badge>
                </template>
            </el-table-column>

            <el-table-column label="Volunteer"
                             min-width="100px"
                             prop="status"
                             >
                <template v-slot="{row}">
                    <user-icon :firstName="row.volunteer.firstName" 
                            :lastName="row.volunteer.lastName"
                            :userId="row.userId"></user-icon>
                </template>
            </el-table-column>

            <el-table-column v-if="thisLocationType == 'retailerLead' || thisLocationType == 'retailer' || thisLocationType == 'admin'" label="Charity" 
                             min-width="170px">
                <template v-slot="{row}">
                    <location-icon :logo="row.charity.logo" :name="row.charity.name" avatarSize="sm"></location-icon>
                </template>
            </el-table-column>

            <el-table-column v-if="thisLocationType == 'retailerLead' || thisLocationType == 'charity' || thisLocationType == 'admin'" label="Retailer" 
                             min-width="170px">
                <template v-slot="{row}">
                    <location-icon :logo="row.retailer.logo" :name="row.retailer.name" avatarSize="sm"></location-icon>
                </template>
            </el-table-column>

            <el-table-column label="Pickup Time"
                             prop="completion"
                             min-width="120px"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{row.timeString}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            
        </el-table>

        <div v-if="usePagination" class="card-footer py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="resultsPerPage" :total="filteredDrops.length"></base-pagination>
        </div>
    </div>
</template>
<script>
  // Imports  
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui';
  import UserIcon from '@/components/UserIcon';
  import LocationIcon from '@/components/LocationIcon';
  import moment from 'moment';
  import DropProcessor from '../../util/DropProcessor';
  //
  export default {
    name: 'drop-status-card',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      UserIcon,
      LocationIcon
    },

    props:[
        'usePagination',
        'resultsPerPage',
        'drops',
        'thisLocationType',
        'showBranchFilter'
    ],
    
    data() {
        return {
            branchFilter: null,
            currentPage: 1
        };
    },
    computed:{
        processedDrops: function(){
            return DropProcessor.processDrops(this.currentPage, this.resultsPerPage, this.drops);
        },

        filteredDrops() {
            if(!this.branchFilter) {
                return this.drops;
            }

            return this.drops.filter(d => d.retailerId === this.branchFilter);
        },

        dropBranches() {
            let branchesNotUnique = this.drops.map((d) => { return { id: d.retailer.id, name: d.retailer.name } });

            let branchesUnique = [];

            for(let branch of branchesNotUnique) {
                if(!branchesUnique.find(b => b.id === branch.id)) {
                    branchesUnique.push(branch);
                }
            }

            return branchesUnique;
        }
    },
    methods: {
        moment: function () {
            return moment();
        },
    },

    watch:{
        currentPage: function(){
            
        }
    }
  }
</script>